const PAGE_UI_ACTIONS = {
  create_customer: {
    name: 'create_customer',
    title: 'Create Customer'
  },
  view_customer: {
    name: 'view_customer',
    title: 'View Customer'
  },
  view_distributor_list: {
    name: 'view_distributor_list',
    title: 'View Distributor List Tab'
  },
  view_distributor_details: {
    name: 'view_distributor_details',
    title: 'View Distributor'
  },
  view_customer_challans: {
    name: 'view_customer_challans',
    title: 'View Customer Challans'
  },
  view_user_documents: {
    name: 'view_user_documents',
    title: 'View User Documents Tab'
  },
  view_customer_battery_swaps: {
    name: 'view_customer_battery_swaps',
    title: 'View Customer Battery Swaps'
  },
  view_customer_transactions: {
    name: 'view_customer_transactions',
    title: 'View Customer Transactions'
  },
  view_customers_under_fo_list: {
    name: 'view_customers_under_fo_list',
    title: 'View Customers under fleet owner'
  },
  view_fleet_owner_groups_list: {
    name: 'view_fleet_owner_groups_list',
    title: 'View fleet owner groups'
  },
  view_fleet_owner_details: {
    name: 'view_fleet_owner_details',
    title: 'View Fleet Owner'
  },
  update_customer: {
    name: 'update_customer',
    title: 'Update Customer'
  },
  block_customer: {
    name: 'block_customer',
    title: 'Block Customer'
  },
  delete_pin_code: {
    name: 'delete_pin_code',
    title: 'Delete PIN Code'
  },
  edit_pin_code: {
    name: 'edit_pin_code',
    title: 'Edit PIN Code'
  },
  dissociate_pin_code: {
    name: 'dissociate_pin_code',
    title: 'Dissociate PIN Code'
  },
  create_offer: {
    name: 'create_offer',
    title: 'Create Offer'
  },
  update_offer: {
    name: 'update_offer',
    title: 'Update Offer'
  },
  create_crm_user: {
    name: 'create_crm_user',
    title: 'Create Crm User'
  },
  update_crm_user: {
    name: 'update_crm_user',
    title: 'Update Crm User'
  },
  create_scheme: {
    name: 'create_scheme',
    title: 'Create Scheme'
  },
  update_scheme: {
    name: 'update_scheme',
    title: 'Update Scheme'
  },
  create_security_amount: {
    name: 'create_security_amount',
    title: 'Create Security Amount'
  },
  update_security_amount: {
    name: 'update_security_amount',
    title: 'Update Security Amount'
  },
  create_addon: {
    name: 'create_addon',
    title: 'Create Addon'
  },
  update_addon: {
    name: 'update_addon',
    title: 'Update Addon'
  },
  create_offer_addon: {
    name: 'create_offer_addon',
    title: 'Create Offer Addon'
  },
  update_offer_addon: {
    name: 'update_offer_addon',
    title: 'Update Offer Addon'
  },
  create_battery_model: {
    name: 'create_battery_model',
    title: 'Create Battery Model'
  },
  update_battery_model: {
    name: 'update_battery_model',
    title: 'Update Battery Model'
  },
  create_service_center: {
    name: 'create_service_center',
    title: 'Create Service Center'
  },
  view_service_center: {
    name: 'view_service_center',
    title: 'View Service Center'
  },
  update_service_center: {
    name: 'update_service_center',
    title: 'Update Service Center'
  },
  update_state: {
    name: 'update_state',
    title: 'Update State'
  },
  view_operators_tab_list: {
    name:'view_operators_tab_list',
    title: 'View Operators Tab'
  },
  block_unblock_operator: {
    name: 'block_unblock_operator',
    title: 'Block or Unblock Operator'
  },
  archive_unarchive_operator: {
    name: 'archive_unarchive_operator',
    title: 'Archive or Unarchive Operator'
  },
  view_batteries_tab_list: {
    name:'view_batteries_tab_list',
    title: 'View Batteries Tab'
  },
  view_charging_stations_tab_list: {
    name:'view_charging_stations_tab_list',
    title: 'View Charging Stations Tab'
  },
  view_rfids_tab_list: {
    name:'view_rfids_tab_list',
    title: 'View Rfids Tab'
  },
  view_partner_asset_bills_tab_list: {
    name: 'view_partner_asset_bills_tab_list',
    title: 'View Partner Asset Bills Tab'
  },
  create_complaint_category: {
    name: 'create_complaint_category',
    title: 'Create Complaint Category'
  },
  update_complaint_category: {  
    name: 'update_complaint_category',
    title: 'Update Complaint Category'
  },
  view_vehicles: {  
    name: 'view_vehicles',
    title: 'View Vehicles'
  },
  view_rental_customer: {
    name: 'view_rental_customer',
    title: 'View Rental Customer'
  },
  view_service_center_work_orders_tab_list: {
    name: 'view_service_center_work_orders_tab_list',
    title: 'View Complaints Tab'
  },
  view_work_order_details: {
    name: 'view_work_order_details',
    title: 'View Work Order'
  },
  view_service_center_coordinators_tab_list: {
    name: 'view_service_center_coordinators_tab_list',
    title: 'View Coordinators Tab'
  },
  view_service_center_technicians_tab_list: {
    name: 'view_service_center_technicians_tab_list',
    title: 'View Technician Tab'
  },
  view_service_center_rfids_tab_list: {
    name: 'view_service_center_rfids_tab_list',
    title: 'View Rfids Tab'
  },
  view_service_center_batteries_tab_list: {
    name: 'view_service_center_batteries_tab_list',
    title: 'View Batteries Tab'
  },
  view_service_center_vehicles_tab_list: {
    name: 'view_service_center_vehicles_tab_list',
    title: 'View Vehicles Tab'
  },
  view_service_center_operational_pincodes_tab_list: {
    name: 'view_service_center_operational_pincodes_tab_list',
    title: 'View Operational Pincodes Tab'
  },
  view_fleet_owner_lease_offers: {
    name: 'view_fleet_owner_lease_offers',
    title: 'View Lease Offers'
  },
  create_lease_offer: {
    name: 'create_lease_offer',
    title: 'Create Lease Offer'
  },
  update_lease_offer: {
    name: 'update_lease_offer',
    title: 'Update Lease Offer'
  },
  roll_over_configs_for_lease_offer: {
    name: 'roll_over_configs_for_lease_offer',
    title: 'Roll Over Configurations For Lease Offer'
  },
  create_rollover_config: {
    name: 'create_rollover_config',
    title: 'Create Rollover configuration for Lease Offer'
  },
  update_rollover_config: {
    name: 'update_rollover_config',
    title: 'Update Rollover Configuration for Lease Offer'
  },
  create_head_user: {
    name: 'create_head_user',
    title: 'Create Head User'
  },
  update_head_user: {
    name: 'update_head_user',
    title: 'Update Head User'
  },
  map_head_user: {
    name: 'map_head_user',
    title: 'Map Head User'
  },
  create_vak: {
    name: 'create_vak',
    title: ' Create VAK'
  },
  update_vak: {
    name: 'update_vak',
    title: 'Update VAK'
  },
  create_leads_earning_config: {
    name: 'create_leads_earning_config',
    title: 'Create Leads Earning Config'
  },
  update_leads_earning_config: {
    name: 'update_leads_earning_config',
    title: 'Update Leads Earning Config'
  },
  create_service_type_mapping: {
    name: 'create_service_type_mapping',
    title: 'Create Service Type Mapping'
  },
  update_service_type_mapping: {
    name: 'update_service_type_mapping',
    title: 'Update Service Type Mapping'
  },
  delete_area_user_mapping: {
    name: 'delete_area_user_mapping',
    title: 'Delete User Mapping'
  },
  view_rental_battery_swaps_tab: {
    name: 'view_rental_battery_swaps_tab',
    title: 'View Rental Customer Swap Tab'
  },
  view_rental_customer_wallet_transactions_tab: {
    name: 'view_rental_customer_wallet_transactions_tab',
    title: 'Rental Customer wallet Transaction'
  },
  view_rental_bookings_tab: {
    name: 'view_rental_bookings_tab',
    title: 'View Rental Bookings Tab'
  },
  view_partner_billing: {
    name: 'view_partner_billing',
    title: 'View Partner Billing'
  },
  view_date_wise_swap_earnings: {
    name: 'view_date_wise_swap_earnings',
    title: 'View Date Wise Swap Earnings'
  },
  view_partner_billing_status_update: {
    name: 'view_partner_billing_status_update',
    title: 'View Action to update partner billing status'
  }, 
  view_circle: {
    name: 'view_circle',
    title: 'View Circle'
  },
  create_circle: {
    name: 'create_circle',
    title: 'Create Circle'
  },
  update_circle: {
    name: 'update_circle',
    title: 'Update Circle'
  },
  create_pin_code: {
    name: 'create_pin_code',
    title: 'Create PIN code'
  },
  view_cluster: {
    name: 'view_cluster',
    title: 'View Cluster'
  },
  create_cluster: {
    name: 'create_cluster',
    title: 'Create Cluster'
  },
  update_cluster: {
    name: 'update_cluster',
    title: 'Update Cluster'
  },
  view_electricity_billing: {
    name: 'view_electricity_billing',
    title: 'View Electricity Billing'
  },
  approve_tally_transaction: {
    name: 'approve_tally_transaction',
    title: 'Approve Tally Transaction'
  },
  reject_tally_transaction: {
    name: 'reject_tally_transaction',
    title: 'Reject Tally Transaction'
  },
  block_unblock_rfid_card: {
    name: 'block_unblock_rfid_card',
    title: 'Block Voltup ID Card (RFID Card)'
  },
  mark_defective_rfid_card: {
    name: 'mark_defective_rfid_card',
    title: 'Mark Defective Voltup ID Card (RFID Card)'
  },
  create_technician: {
    name: 'create_technician',
    title: 'Create Technician'
  },
  update_technician: {
    name: 'update_technician',
    title: 'Update Technician'
  },
  create_coordinator: {
    name: 'create_coordinator',
    title: 'Create Coordinator'
  },
  update_coordinator: {
    name: 'update_coordinator',
    title: 'Update Coordinator'
  }
}

export default PAGE_UI_ACTIONS;
